import React from 'react';
import i18n from 'i18next';
import { Namespace } from '../../../../../translation/namespace';
import { ContentParagraph, ContentParagraphModifier } from '../../../../../_lib/components/ContentParagraph';
import { FormUtils, useFormContext } from '../../../../molecules/Form';
import { createFormElement } from '../../../../molecules/Form/FormFactory';
import LiveRegion from '../../../../atoms/LiveRegion/LiveRegion';
import { InteractionStatus } from '../../../../../types/InteractionStatus';
import { FormSubmitButton } from '../../../../molecules/Form/components/FormSubmitButton/FormSubmitButton';

function getStatusMessages() {
  return {
    [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(
      i18n.t(`${Namespace.PasswordReset}:request:status.success`),
      InteractionStatus.SUCCESS,
    ),
  };
}
export default function PasswordForgotTemplate() {
  const { inputs, onChange, submitActionEnabled, getStatus } = useFormContext();
  return (
    <>
      <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>
        {i18n.t(`${Namespace.PasswordReset}:request.formHelp`)}
      </ContentParagraph>
      {createFormElement()(inputs.email, 'forgotPassword', onChange, i18n.t(`${Namespace.glossary}:eMailAddress`))}
      <FormSubmitButton buttonLabel={i18n.t(`${Namespace.glossary}:send`)} enabled={submitActionEnabled()} />
      <LiveRegion htmlTag="div" invisible={false} ariaAtomic ariaLive="polite">
        {getStatus(getStatusMessages())}
      </LiveRegion>
    </>
  );
}
